import React from 'react';
import { useTranslation } from 'react-i18next';
import SVGInfo from '../../../common/assets/svg/icons/SVGInfo';

interface InfoBoxProps {
  descriptionText: string;
}
export default function InfoBox({ descriptionText }: InfoBoxProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="flex w-full transform flex-row items-center justify-center rounded-lg border border-border p-2">
      <SVGInfo />
      <div className="w-full text-left pl-4">
        <div className="text-sm leading-5 text-textParagraph w-full text-left" data-testid="INFO_BOX_DESCRIPTION">
          {t(descriptionText)}
        </div>
      </div>
    </div>
  );
}
